webpackJsonp([59247458723282],{

/***/ 948:
/***/ (function(module, exports) {

	module.exports = {"title":"Gæði skákþjálfunar","headline":"Æfðu með hugbúnaði sem er hannaður með það fyrir augum að líkja eftir einkakennslu topp skákþjálfara","p1":"Héðinn er annar tveggja FIDE Senior Trainers á Íslandi, sem er hæsta mögulega skákþjálfaragráðan. Einnig lauk hann þýskri A þjálfara gráðu.","p2":"Hann hefur alþjóðlega reynslu af skákkennslu, hefur um langt árabil kennt fremstu börnum og unglingum landsins, en einnig starfað sem skákþjálfari í Þýskalandi og í New York í Bandaríkjunum þar sem hann hefur kennt börnum og fullorðnum í skákklúbbum, einkatímum og sem hluti af skólastarfi.","p3":"Mynsturþjálfunaraðferðin sem boðið er uppá er afrakstur þróunarvinnu, sem Héðinn kynnti fyrst til sögunnar í bæði þýsku A þjálfara ritgerðinni og einnig ritgerð sem var hluti af FIDE Trainer gráðunni. Markmið aðferðarinnar er að kenna skák á árangursríkan hátt, en skv. fræðunum er talið að aukin þekking á skákmynstrum haldist í hendur við aukna færni í skák.","p4":"Skák með vinum í New York:"}

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(12);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Link = __webpack_require__(8);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _reactstrap = __webpack_require__(9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var content = props.content;
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper post-image' },
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: props.data.img.childImageSharp.sizes,
	        backgroundColor: 'rgba(51,102,255,0.4)'
	      })
	    ),
	    _react2.default.createElement(
	      _reactstrap.Container,
	      { className: 'my-5 pb-5' },
	      _react2.default.createElement(
	        'h3',
	        { className: 'mb-3 text-color-title' },
	        content.title
	      ),
	      _react2.default.createElement(
	        'h5',
	        { className: 'text-color-subtitle' },
	        content.headline
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p1
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p2
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p3
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        content.p4
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://fivethirtyeight.com/features/one-last-dispatch-from-the-land-of-chess-kings-and-billionaires/' },
	        'https://fivethirtyeight.com/features/one-last-dispatch-from-the-land-of-chess-kings-and-billionaires/'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'text-right my-5' },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: '/competency' },
	          'Back to competency'
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _trainingLayout = __webpack_require__(165);
	
	var _trainingLayout2 = _interopRequireDefault(_trainingLayout);
	
	var _training = __webpack_require__(948);
	
	var _training2 = _interopRequireDefault(_training);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Sk\xE1kgreind | G\xE6\xF0i sk\xE1k\xFEj\xE1lfunar'
	      )
	    ),
	    _react2.default.createElement(_trainingLayout2.default, _extends({ content: _training2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-competency-training-index-is-js-cec77895642ebaad0ca5.js